<template>
	<el-tabs v-bind:value="selectionActiveName" type="card" @tab-click="handleClick">
	    <el-tab-pane label="巡检线路" name="patrol_road" path="/patrol/road_manage"></el-tab-pane>
	    <el-tab-pane label="数据查询" name="patrol_data" path="/patrol/data_manage"></el-tab-pane>
	    <el-tab-pane label="巡检点管理" name="patrol_card" path="/patrol/card_manage"></el-tab-pane>
    </el-tabs>
</template>

<script>
export default {
  name: 'patrolnav_tabs',
  props: {
    selectionActiveName: String
  },
  data() {
    return {
        activeName: ""
    }
  },
  methods: {
    handleClick: function(tab, event) {
      //console.log(tab);
      this.$router.push(tab.$attrs.path);
    },
    activeTabPane: function(name) {
      this.selectionActiveName = name;
    }
  },
  setup(props) {
    console.log("setup>" + props.selectionActiveName);
  }
}
</script>